import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    bannerOffers: [],
  },
  getters: {},
  mutations: {
    updateBannerOffer(state, payload) {
      state.bannerOffers = payload;
    }
  },
  actions: {
    bannerOfferApi({ commit, state }, payload) {
      ApiCalls.BANNER_OFFERS_API({
        headers: Headers(),
        payload: LocalStorageFunc.storeId(),
      })
        .then(function (response) {
          if (response?.data?.length > 0) {
            commit("updateBannerOffer", response.data);
          }
        })
        .catch(function (error) {
          commit("updateBannerOffer", {});
        });
    },
  },
};
